import { WatchQueryFetchPolicy } from '@apollo/client';

import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import { GET_STUDENT_ANSWER_BY_ID } from '../present/activity-answers.graphql';
import type {
  GetStudentAnswerByIdQuery,
  GetStudentAnswerByIdQueryVariables,
} from '../present/activity-answers.graphql.generated';
import { ActivitiesContentType } from 'global/constants';
import useUserData from 'approot/shared/user/user-data';
import { studentAuthApolloContextOption } from 'approot/student-class-to-do/student-class-to-do.utils';

const useGetStudentAnswerById = ({
  uuid,
  classId,
  contentId,
  contentType,
  skip,
  fetchPolicy,
}: {
  uuid: string;
  classId: number;
  contentId: number;
  contentType: ActivitiesContentType;
  skip?: boolean;
  fetchPolicy?: WatchQueryFetchPolicy;
}) => {
  const { isSignedIn, isStudentSignedIn } = useUserData();

  const { data, loading, error } = useLoggingQuery<
    GetStudentAnswerByIdQuery,
    GetStudentAnswerByIdQueryVariables
  >(
    GET_STUDENT_ANSWER_BY_ID,
    {
      context: isStudentSignedIn ? studentAuthApolloContextOption() : undefined,
      skip,
      fetchPolicy,
      variables: {
        input: {
          classId,
          contentId,
          contentType,
          uuid,
        },
      },
    },
    isSignedIn
  );

  return {
    data,
    loading,
    error,
  };
};

export default useGetStudentAnswerById;
